<div id="layout-wrapper">

  <app-topbar *ngIf="!isStreamingwindows" (settingsButtonClicked)="onSettingsButtonClicked()" (mobileMenuButtonClicked)="onToggleMobileMenu()">
  </app-topbar>

  <app-sidebar *ngIf="!isStreamingwindows" [isCondensed]="isCondensed"></app-sidebar>

  <div class="main-content" *ngIf="!isStreamingwindows">
    <div *ngIf="!isStreamingwindows" class="page-content">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>
    <!-- footer -->
    <app-footer *ngIf="!isStreamingwindows"></app-footer>
  </div>
  <div *ngIf="isStreamingwindows">
    <div *ngIf="isStreamingwindows" style="padding: 10px;">
      <!-- content -->
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<app-rightsidebar *ngIf="!isStreamingwindows"></app-rightsidebar>
